import { memo } from 'react';

import { WorkspaceUploadsTray } from '~/components/v2/components/workspace/workspace-uploads/WorkspaceUploadsTray';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { canCreateAsset } from '~/utils/permissions/assetPermissions';

export const WorkspaceUploads = memo(() => {
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();

  if (!canCreateAsset(workspacePermissions)) {
    return null;
  }

  return <WorkspaceUploadsTray />;
});

WorkspaceUploads.displayName = 'WorkspaceUploads';
